<div class="login-details">

    <div class="col-md-8 login-card no-padding display-flex-lg-lg ">
        <h6>Your Account Has Been Successfully Created!</h6>
        <div class="content">
            <h6>A verification link has been sent to your email account.</h6>
            <p>Please click on the link that has just been sent to your email account to verify your email and continue the registration process.</p>
            <button [routerLink]="['/login']">Log In</button>
        </div>
        <div class="footer">
            <p>Didn’t receive anything?&nbsp;<a class="link pointer" (click)="resendMail()">Resend Link</a></p>
        </div>
        <!-- <div class="col-md-5 no-padding img-section">
            <img class="img-responsive" src="assets/images/login.png">
        </div> -->
        <!-- <div class="col-md-7 no-padding center sign-confirmation">
            <img class="header-logo" src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1607238429/truventor/tru-logo.png">

            <h3>Thank You</h3>
            <p>Thank you for registering with Truventor, Please check your inbox and verify your email before you get started.</p>
        </div> -->

    </div>